import { calculateAccessibleText } from './colorSchemeUtils';
import { ColorScheme } from '../schema/ColorScheme';
import { getRawPalette, MiniPalette } from 'mini-theme';

/**
 * gets the default color schemes for Mini
 */
export const getColorSchemeForTheme = (themePalette: MiniPalette): ColorScheme => {
    const colorScheme = {
        text: '',
        textAlt: '',
        accessibleText: {
            schemePrimaryBackground: '',
            schemeLighterBackground: '',
            msColorWhiteBackground: '',
            msColorNeutralLighterBackground: '',
        },
        schemeDarker: themePalette.themeDarker,
        schemeDark: themePalette.themeDark,
        schemeDarkAlt: themePalette.themeDarkAlt,
        schemePrimary: themePalette.themePrimary,
        schemeSecondary: themePalette.themeSecondary,
        schemeTertiary: themePalette.themeTertiary,
        schemeLight: themePalette.themeLight,
        schemeLighter: themePalette.themeLighter,
        schemeLighterAlt: themePalette.themeLighterAlt,
        colorName: () => '',
    };
    colorScheme.accessibleText = calculateAccessibleText(colorScheme);
    colorScheme.text = colorScheme.accessibleText.schemePrimaryBackground;
    colorScheme.textAlt = colorScheme.accessibleText.schemeLighterBackground;

    return colorScheme;
};

export const getCurrentThemeColorScheme = (): ColorScheme =>
    getColorSchemeForTheme(getRawPalette());
